import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2b31cd10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group-edit-wrap el-card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "group-edit__tip-trigger",
  role: "button",
  tabindex: "0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont team-admin-nav-icon-zhongduanbiaoshi" })
], -1))
const _hoisted_3 = {
  ref: "scrollerRef",
  style: {"max-height":"300px","overflow":"auto"}
}
const _hoisted_4 = {
  key: 0,
  class: "node-tip"
}
const _hoisted_5 = {
  key: 1,
  class: "tips-row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_tree = _resolveComponent("el-tree")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showGroupTipPopover)
      ? (_openBlock(), _createBlock(_component_el_popover, {
          key: 0,
          placement: "bottom-start",
          trigger: "hover",
          width: _ctx.width?_ctx.IS_JP_ONLY_BUILD ? 460 : 400:400,
          offset: 0,
          effect: "light"
        }, {
          reference: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "groupTipPopover", {}, undefined, true)
          ]),
          _: 3
        }, 8, ["width"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_tree, {
        ref: "treeNode",
        class: "",
        data: _ctx.groupData?.group_id && [_ctx.groupData],
        "node-key": "group_id",
        "expand-on-click-node": false,
        "check-on-click-node": "",
        props: { label: 'name', disabled: () => _ctx.disabled },
        "default-expand-all": "",
        "default-checked-keys": _ctx.modelValue,
        onCheck: _ctx.handleCheck,
        "empty-text": "",
        "check-strictly": "",
        "show-checkbox": "",
        style: _normalizeStyle({ maxHeight: _ctx.maxHeight + 'px' })
      }, {
        default: _withCtx(({ node, data }) => [
          _createElementVNode("span", null, _toDisplayString(node.label) + "（" + _toDisplayString(data.count) + "）", 1),
          (_ctx.strategyOver.type && +data.strategy_id > 0 && data.strategy_id !== _ctx.strategyOver.current)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('policyManage.hasOtherStrategy')), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data", "props", "default-checked-keys", "onCheck", "style"])
    ], 512),
    (_ctx.showTip)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('policyManage.selectedGroupCount', { n: _ctx.modelValue.length || 0 })), 1))
      : _createCommentVNode("", true)
  ]))
}